// Source: app/scripts/controllers/published-auctions.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('PublishedAuctionsController', [
  '$scope',
  '$filter',
  'Downloader',
  '$location',
  '$modal',
  'toaster',
  'Auction',
  '$rootScope',
  'Nav',
  'ProductSubcategories',
  '$cookieStore',
  function ($scope, $filter, Downloader, $location, $modal, toaster, Auction, $rootScope, Nav, ProductSubcategories, $cookieStore) {

  $scope.goToEcounterSysytem = function(){
    $rootScope.sytem = 'E_COUNTER';
    $cookieStore.put('systemToken', 'E_COUNTER');

    Nav.newFetch($rootScope.sytem);
    $rootScope.showOption = 2;


  };

    $scope.goToEauctionSysytem = function(){
      $rootScope.sytem = 'E_AUCTION';
      $cookieStore.put('systemToken', 'E_AUCTION');

      if($rootScope.user){
      Nav.newFetch($rootScope.sytem);
      }else{
        ProductSubcategories.categoryNavigation();
      }
      $rootScope.showOption = 1;
    };

    $scope.onAuctionCrudInit = function (auctionCrud) {

      auctionCrud.preview = function (auction) {
        $location.path("/user_auctions/auction/" + auction.id);
      };

      $scope.auctionCrud.actions = {};
      $scope.auctionCrud.actions.downloadAnnouncement = function (auction) {
        Auction.getAnnouncement({
          id: auction.id
        }, function (data) {
          if (data && data.id) {
            Downloader.download('/data/rest/attachments/' + data.id);
          } else {
            toaster.pop('error', $filter('translate')('generic.error'),
              $filter('translate')("eauction.no_auction_anouncement"));
          }
        });
      }
    };

  }]);
